import { z } from 'zod'

export const VIDEO_CODECS = {
  h264: 'h264',
  h265: 'h265',
  av1: 'av1',
  other: 'other',
} as const
export const videoCodecSchema = z.nativeEnum(VIDEO_CODECS)
export type VideoCodec = z.infer<typeof videoCodecSchema>

export const AUDIO_CODECS = {
  aac: 'aac',
  opus: 'opus',
  mp2: 'mp2',
  other: 'other',
} as const
export const audioCodecSchema = z.nativeEnum(AUDIO_CODECS)
export type AudioCodec = z.infer<typeof audioCodecSchema>

const STREAM_TYPES = {
  video: 'video',
  audio: 'audio',
  other: 'other',
} as const

export const videoStreamSchema = z.object({
  type: z.literal(STREAM_TYPES.video),
  codec: videoCodecSchema,
  profile: z.string().optional(),
  /** Bitrate in kbps */
  bitrate: z.number(),
  width: z.number(),
  height: z.number(),
  framerate: z.number(),
  keyframeInterval: z.number(),
  isInterlaced: z.boolean(),
})
export type VideoStream = z.infer<typeof videoStreamSchema>

export const audioStreamSchema = z.object({
  type: z.literal(STREAM_TYPES.audio),
  codec: audioCodecSchema,
  profile: z.string().optional(),
  /** Bitrate in kbps */
  bitrate: z.number(),
  channels: z.number(),
  sampleRate: z.number(),
})
export type AudioStream = z.infer<typeof audioStreamSchema>

export const otherStreamSchema = z.object({
  type: z.literal(STREAM_TYPES.other),
  /** Bitrate in kbps */
  bitrate: z.number(),
})
export type OtherStream = z.infer<typeof otherStreamSchema>

export const mediaStreamSchema = z.discriminatedUnion('type', [
  videoStreamSchema,
  audioStreamSchema,
  otherStreamSchema,
])
export type MediaStream = z.infer<typeof mediaStreamSchema>

export const mediaInfoSchema = z.object({
  time: z.string(),
  streams: z.array(mediaStreamSchema),
})
export type MediaInfo = z.infer<typeof mediaInfoSchema>
